const formFieldTypes = new Set(['text', 'number', 'date', 'email', 'tel', 'password', 'file', 'select'])

const hasValidSelectOptions = (field: Record<string, unknown>): boolean =>
  field.type !== 'select' ||
  (Array.isArray(field.options) &&
    field.options.length > 0 &&
    field.options.every(
      option =>
        option &&
        typeof option === 'object' &&
        typeof (option as Record<string, unknown>).value === 'string' &&
        typeof (option as Record<string, unknown>).label === 'string'
    ))

export type ArticleBlockContent = {
  type?: string
  markdown?: string
  component_id?: string
  data?: Record<string, unknown>
  form_config?: Record<string, unknown>
}

export type RenderableArticleContent = {
  title?: string
  body_markdown?: string
  blocks?: ArticleBlockContent[]
}

const hasText = (value: unknown): value is string => typeof value === 'string' && value.trim().length > 0

export const isRenderableArticleBlock = (block: ArticleBlockContent): boolean => {
  if (block.type === 'markdown') return hasText(block.markdown)
  if (block.type === 'component') return hasText(block.component_id)

  if (block.type === 'form') {
    const fields = block.form_config?.fields

    return (
      Array.isArray(fields) &&
      fields.length > 0 &&
      fields.every(
        field =>
          field &&
          typeof field === 'object' &&
          hasText((field as Record<string, unknown>).name) &&
          formFieldTypes.has(String((field as Record<string, unknown>).type)) &&
          hasValidSelectOptions(field as Record<string, unknown>)
      )
    )
  }

  return false
}

export const getRenderableArticleBlocks = (
  article: RenderableArticleContent | null | undefined
): ArticleBlockContent[] => (Array.isArray(article?.blocks) ? article.blocks : []).filter(isRenderableArticleBlock)

export const hasRenderableArticleContent = (article: RenderableArticleContent | null | undefined): boolean =>
  hasText(article?.title) || hasText(article?.body_markdown) || getRenderableArticleBlocks(article).length > 0
